import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import Dialog from '../../atoms/feedback/Dialog'
import { useClientEvaluationCommentDeleteDialog } from '../../../hooks/useDialog'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Button from '../../atoms/inputs/Button'
import { CompanyActions } from '../../../store/company'
import Label from '../../atoms/display/Label'

export default function ClientEvaluationCommentDeleteDialog() {
  const { state, close } = useClientEvaluationCommentDeleteDialog()
  const dispatch = useDispatch()

  const handleSave = useCallback(() => {
    if (state) {
      dispatch(
        CompanyActions.deleteClientEvaluationComment({
          clientCompanyId: state.companyId,
          commentId: state.commentId,
        })
      )
    }
  }, [dispatch, state])

  return (
    <Dialog
      open={state !== undefined}
      onClose={close}
      title="評価コメントの削除"
      actions={
        <FlexRow>
          <Button variant="text" onClick={close}>
            キャンセル
          </Button>
          <Button color="caution" onClick={handleSave}>
            削除
          </Button>
        </FlexRow>
      }
    >
      <FlexColumn>
        <Label text={state?.comment ?? ''} whiteSpace="pre-wrap" />
      </FlexColumn>
    </Dialog>
  )
}
